var Keys = /*#__PURE__*/ function(Keys) {
    Keys["Backspace"] = "Backspace";
    Keys["Tab"] = "Tab";
    Keys["Enter"] = "Enter";
    Keys["Space"] = " ";
    Keys["Shift"] = "Shift";
    Keys["Control"] = "Control";
    Keys["Alt"] = "Alt";
    Keys["Command"] = "Meta";
    Keys["Escape"] = "Escape";
    Keys["PageUp"] = "PageUp";
    Keys["PageDown"] = "PageDown";
    Keys["ArrowLeft"] = "ArrowLeft";
    Keys["ArrowUp"] = "ArrowUp";
    Keys["ArrowRight"] = "ArrowRight";
    Keys["ArrowDown"] = "ArrowDown";
    Keys["Delete"] = "Delete";
    Keys["Fn"] = "Fn";
    Keys["End"] = "End";
    Keys["Home"] = "Home";
    Keys["Clear"] = "Clear";
    Keys["Insert"] = "Insert";
    // If holding shift, these are capitalized. If case doesn't matter, compare with `e.key.toLowerCase()`
    Keys["A"] = "a";
    Keys["B"] = "b";
    Keys["C"] = "c";
    Keys["D"] = "d";
    Keys["E"] = "e";
    Keys["F"] = "f";
    Keys["G"] = "g";
    Keys["H"] = "h";
    Keys["I"] = "i";
    Keys["J"] = "j";
    Keys["K"] = "k";
    Keys["L"] = "l";
    Keys["M"] = "m";
    Keys["N"] = "n";
    Keys["O"] = "o";
    Keys["P"] = "p";
    Keys["Q"] = "q";
    Keys["R"] = "r";
    Keys["S"] = "s";
    Keys["T"] = "t";
    Keys["U"] = "u";
    Keys["V"] = "v";
    Keys["W"] = "w";
    Keys["X"] = "x";
    Keys["Y"] = "y";
    Keys["Z"] = "z";
    Keys["Zero"] = "0";
    Keys["One"] = "1";
    Keys["Two"] = "2";
    Keys["Three"] = "3";
    Keys["Four"] = "4";
    Keys["Five"] = "5";
    Keys["Six"] = "6";
    Keys["Seven"] = "7";
    Keys["Eight"] = "8";
    Keys["Nine"] = "9";
    Keys["F1"] = "F1";
    Keys["F2"] = "F2";
    Keys["F3"] = "F3";
    Keys["F4"] = "F4";
    Keys["F5"] = "F5";
    Keys["F6"] = "F6";
    Keys["F7"] = "F7";
    Keys["F8"] = "F8";
    Keys["F9"] = "F9";
    Keys["F10"] = "F10";
    Keys["F11"] = "F11";
    Keys["F12"] = "F12";
    Keys["Hyphen"] = "-";
    Keys["ForwardSlash"] = "/";
    Keys["BackSlash"] = "\\";
    return Keys;
}({});

export { Keys };
//# sourceMappingURL=keys.mjs.map
